// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    project: "telescope",
    env: "dev",
    displayLogs: true,
    languageName: "dev_e2e_language",
    gateWayHost: "https://qa-api-wms.delhivery.com/wms-dev",
    gateWayHostWMS: "https://qa-api-wms.delhivery.com/wms-dev",
    baseUrl: "./assets/data",
    AUTH_CLIENT_ID: "nEyPJYGJSd7SW1usYkYkZNM1fDXDZqfz",
    AUTH_DOMAIN: "delhivery-dev.au.auth0.com",
    AUTH_RESPONSE_TYPE: "token id_token",
    AUTH_REDIRECT_URI: "https://dev-e2e-visibility.delhivery.com",
    UMS_USER_DETAIL: "https://api-stage-ums.delhivery.com/users/self/",
    AUTH_AUDIENCE: "Telescope",
    accessToken: "dev_ums_token",
    UMS_TOKEN_CONVERT_API: "https://api-stage-ums.delhivery.com/v2/assume-auth0-token/",
    GA_TRACKING_ID: "UA-78887659-18",
    UMS_HOST : "https://api-stage-ums.delhivery.com",
    PASSWORD_EXPIRE: "https://ums-dev.delhivery.com/#!/update-password/",
    UMS_APP_ID: '1016',
};